<template>
  <div class="chair-message-edit">
    <div v-if="!editContainerShown">
      <v-btn
          v-if="!!chairMessage.message && chairMessage.isChairMessageVisible && chairMessage.canEdit"
          data-qe-id="chair_message_edit_btn"
          icon
          @click="resetChairMessage">
        <i class="fas fa-pencil-alt"></i>
      </v-btn>
      <v-btn
          v-else
          class="chair-message-edit__new-chair-message"
          color="ypo_blue white--text"
          data-qe-id="chair_message_add_new_btn"
          @click="showEditContainer">
        {{ communityCommonConstant.chairMessage.ADD_CHAIR_MESSAGE }}
      </v-btn>
    </div>
    <v-card v-else>
      <v-flex class="chair-message-edit__title" xs12>
        <v-flex data-qe-id="edit_chair_msg_title_header" tag="h2">
          {{ communityCommonConstant.chairMessage.TITLE_HEADER }}
        </v-flex>
        <div v-for="chair in chapterChairs" :key="chair.lastName" class="imagesection">
          <v-flex>
            <v-avatar size="120px">
              <v-img :onerror="imageErrorFallback(chair.fallbackProfileImageUrl)" :src="chair.userProfileImageUrl"
                     class="chair-message-edit__img-border"/>
            </v-avatar>
            <h5>
              <span class="chair-message-edit__color-light">{{ getFullName(chair) }}</span>
            </h5>
            <span class="chair-message-edit__text-Position" data-qe-id="chair_msg_dialog_chair_title">
                                    {{ communityChairTitle }}
                                </span>
          </v-flex>

        </div>
      </v-flex>
      <v-card-text pl-0 pr-0>
        <v-container pl-0 pr-0>
          <v-layout wrap>
            <v-flex class="chair-message-edit__image" xs12>
              <div v-if="!!imageUrl" class="chair-message-edit__image-frame">
                <div class="chair-message-edit__image-container">
                  <v-img
                      :src="imageUrl"
                      aspect-ratio="1.75"
                      contain
                      data-qe-id="edit_chair_msg_uploaded_image"
                      max-height="150"></v-img>
                  <v-icon
                      class="chair-message-edit__image-remove"
                      data-qe-id="chair_message_image_remove_btn"
                      @click="removePostImage">close
                  </v-icon>
                </div>
              </div>
            </v-flex>
            <v-flex class="chair-message-edit__editor" sm12>
              <ck-editor
                  v-model="newChairMessage.message"
                  :can-upload-image="!imageUrl"
                  :editor-id="ckEditorId"
                  :editor-type="ckEditorType.BASIC"
                  :input-filter-for-image="inputFilterForImageFile"
                  :update-image-upload="updateFile"
                  height="350"
                  data-qe-id="edit_chair_msg_ckeditor">
              </ck-editor>
            </v-flex>
          </v-layout>
        </v-container>
        <status-bar :action="addPostAction"></status-bar>
      </v-card-text>

      <v-flex pa-1 text-xs-right>
        <v-btn
            class="primary_btn transparent"
            data-qe-id="cancel_dialog_btn"
            flat
            @click.native="resetChairMessage">
          {{ appCommonConstants.CANCEL }}
        </v-btn>
        <v-btn
            class="primary_btn"
            dark
            data-qe-id="save_dialog_btn"
            @click.native="saveChairMessage">
          {{ appCommonConstants.SAVE }}
        </v-btn>
      </v-flex>

    </v-card>
  </div>
</template>

<script>
import { communityCommonConstant } from "../communityCommon.constant";
import { appCommonConstants } from "../../appCommon.constants";
import { mapActions, mapState } from "vuex";
import { storeAction } from "../../../store/storeActions.constant";
import CkEditor from "../../CkEditor/CkEditor";
import {
  getUploadedFileBase64,
  inputFilterForImageFile,
} from "../../../common/utils/fileUploader";
import StatusBar from "../../StatusBar/StatusBar";
import { imageErrorFallback, getRandomId } from "../../../common/utils/utils";
import { ckEditorType } from "../../../plugins/CkEditor/ckEditorTypes.config";
import sortBy from "lodash/sortBy";
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "AddChairMessage",
  components: {
    StatusBar,
    CkEditor,
  },
  props: {
    chairMessage: {
      type: Object,
      required: true,
    },
    communityChairTitle: {
      type: String,
      default: "",
    },
  },
  created() {
    this.newChairMessage = cloneDeep(this.chairMessage);
    this.files = [];
  },
  data() {
    return {
      editContainerShown: false,
      chairMessageDialog: false,
      files: [],
      communityCommonConstant,
      ckEditorType,
      appCommonConstants,
      newChairMessage: {},
      ckEditorId: getRandomId(),
    };
  },
  methods: {
    ...mapActions({
      createChairMessage: `chapter/${storeAction.createChairMessage}`,
    }),
    getFullName(chapterChair) {
      return `${chapterChair.firstName} ${chapterChair.lastName}`;
    },
    imageErrorFallback,
    resetChairMessage() {
      this.newChairMessage = cloneDeep(this.chairMessage);
      this.files = [];
      this.toggleEditMode();
    },
    toggleEditMode() {
      this.editContainerShown = !this.editContainerShown;
      this.$emit("editToggled", this.editContainerShown);
    },
    showEditContainer() {
      this.toggleEditMode();
    },
    async saveChairMessage() {
      const {
        id,
        message,
        chairMessageImage,
        chapterChairs,
      } = this.newChairMessage;

      const chairMessageSaveObj = {
        id,
        message,
        chairMessageImage,
        chapterChairs,
        preserveExisitngChairMessageImage: true,
        communityId: this.$route.params.communityId,
      };

      await this.createChairMessage(JSON.parse(JSON.stringify(chairMessageSaveObj)));
      this.toggleEditMode();
    },
    inputFilterForImageFile,
    updateFile(files) {
      if (files && files.length) {
        this.files = files;
        this.newChairMessage.preserveExisitngChairMessageImage = false;
        this.newChairMessage.chairMessageImage = {
          ...this.newChairMessage.chairMessageImage,
          url: this.files[0] && this.files[0].url ? this.files[0].url : "",
        };
        const { file } = this.files[0];
        getUploadedFileBase64(file).then((customJsonFile) => {
          //customJsonFile is your newly constructed file.
          if (customJsonFile) {
            this.newChairMessage.chairMessageImage = {
              data: customJsonFile.base64StringFile,
              contentType: customJsonFile.fileType,
            };
          } else {
            throw new Error("File not loaded.");
          }
        });
      }
    },
    removePostImage() {
      this.newChairMessage.chairMessageImage = {};
      this.newChairMessage.preserveExisitngChairMessageImage = false;
      this.files = [];
    },
  },
  computed: {
    imageUrl() {
      /*eslint-disable-next-line no-nested-ternary*/
      return this.files.length && this.files[0].url ?
          this.files[0].url :
          this.newChairMessage.chairMessageImage &&
          this.newChairMessage.chairMessageImage.url && this.newChairMessage.chairMessageImage.url.includes('/chairmessageimage') ?
              this.newChairMessage.chairMessageImage.url :
              "";
    },
    ...mapState("actionState", ["actions"]),
    addPostAction() {
      return this.actions[storeAction.createChairMessage];
    },
    chapterChairs() {
      if (this.chairMessage.chapterChairs) {
        return sortBy(this.chairMessage.chapterChairs, 'lastName').slice(0, 2);
      }
      return sortBy(this.newChairMessage.chapterChairs, 'lastName').slice(0, 2);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../common/styles/_colors.scss";
@import "../../../common/styles/_responsive.scss";
@import "../../../common/styles/_commonClasses.scss";

.chair-message-edit {
  &__title {
    background-color: $ypo-dark-background-gray;
    text-align: center;
    height: 160px;
    position: relative;

    .imagesection {
      display: inline-flex;
      justify-content: space-around;
      width: 50%;
      margin-top: 20px;
    }

    .v-avatar {
      bottom: 0px;

      img {
        border: 7px solid $ypo-dark-background-gray;
      }

      .v-image {
        border: 7px solid $ypo-dark-background-gray;
      }
    }

    h2 {
      font-weight: 400;
      color: $white;
      padding-top: 45px;
      letter-spacing: 0.25px;
    }
  }

  &__chair-info {
    margin-top: 50px;
  }

  &__editor {
    margin-top: 80px;
  }

  &__image {
    &-upload {
      text-align: right;
    }

    &-frame {
      padding: 10px;
      padding-left: 23px;
      padding-right: 23px;
      max-height: 250px;
      margin-top: 80px;
      overflow-y: auto;
    }

    &-container {
      position: relative;
    }

    &-remove {
      position: absolute !important;
      z-index: 10000;
      top: -10px;
      right: -10px;
      transform: translate3d(50%, 0, 0);
      border: none;
    }
  }

  &__new-chair-message {
    border-radius: 4px;
  }

  &__chair-name {
    text-align: center;
    font-size: 18px !important;
    font-weight: bold;
    color: $ypo-blue;
  }

  &__chair-des {
    text-align: center;
    font-size: 15px !important;
    color: $ypo-blue;
  }

  .heading {
    height: 29px !important;
    width: 170px !important;
    color: rgba(84, 110, 122, 0.9) !important;
    font-family: Raleway, serif !important;
    font-size: 24px !important;
    letter-spacing: 0.17px !important;
    margin-top: 25px;
  }

  &__textarea {
    height: 100%;
    width: 100%;
    border-left: 1px solid $ypo-title-blue-gray;
    border-right: 1px solid $ypo-title-blue-gray;
    border-top: 1px solid $ypo-title-blue-gray;
    border-radius: 4px;
    padding: 8px;
  }

  &__save_btn {
    border: 1px solid #979797 !important;
    border-radius: 4px;
    background-color: $ypo-blue !important;
    font-family: Gentona, Arial, Helvetica, sans-serif !important;
    font-size: 14.44px !important;
    font-weight: bold !important;
    letter-spacing: 1.25px !important;
  }

  &__close_btn {
    border-radius: 4px !important;
    color: #222222 !important;
    font-family: Gentona, Arial, Helvetica, sans-serif !important;
    font-size: 15.44px !important;
    font-weight: 600 !important;
    letter-spacing: 1.25px !important;
    line-height: 16px !important;
    text-align: center !important;
  }

  .v-card__text {
    padding: 20px 20px 0px 20px;
    border-bottom: 1px solid #d8d8d8;
  }

  &__Chapter-Name {
    max-height: 40px;
  }

  &__text-right {
    float: right;
  }

  &__color-Text {
    color: $ypo-blue;
    font-weight: bold;
    float: right;
  }

  &__color-light {
    font-weight: lighter;
    color: $ypo-duskblue;
    text-align: justify;
    text-overflow: ellipsis;
    overflow: hidden;
    padding-top: 0px;
  }

  &__text-Position {
    font-weight: bold;
    text-overflow: ellipsis;
  }

  &__btn-align {
    margin-left: 370px;
    color: $ypo-blue;
    font-weight: bold;
  }

  &__padding-space {
    padding-bottom: 0;
  }

  &__font-format {
    font-weight: lighter;
    margin-top: 25px;
    font-size: 25px;
  }

  &__chapter-name {
    margin-top: 50px;
    text-align: center;
  }

  &__message-desc-border {
    border-bottom: 1px solid $ypo-text-border;
    margin-top: 35px;
  }
}
</style>
<style lang="scss">
.chair-message-edit {
  .photo-uploader__btn {
    padding: 0 5px 5px !important;
    height: 32px;
  }

  .cke_contents {
    height: 350px !important;
  }

  .ck-editor__image-upload {
    top: 30px;
  }
}
</style>
